export default "__VITE_ASSET__CUWv3D_h__"